var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ModalContent', {
    attrs: {
      "flat-chrome": ""
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$translate('title')))]), _c('template', {
    slot: "content"
  }, [_c('Warning', {
    attrs: {
      "type": "info",
      "icon": "mdi-information-outline"
    }
  }, [_vm._v(" " + _vm._s(_vm.$translate('explanation')) + " "), _vm.params.newWarehouse ? _c('p', {
    staticClass: "mb-0 mt-2"
  }, [_vm._v(_vm._s(_vm.$translate('newWarehouse')))]) : _vm._e()]), _c('v-text-field', {
    attrs: {
      "label": _vm.$translate('name'),
      "outlined": "",
      "dense": "",
      "autofocus": "",
      "maxlength": "128",
      "hide-details": "auto",
      "disabled": _vm.saving,
      "error-messages": _vm.error
    },
    on: {
      "keydown": function keydown($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        $event.preventDefault();
        return _vm.submit.apply(null, arguments);
      }
    },
    model: {
      value: _vm.name,
      callback: function callback($$v) {
        _vm.name = $$v;
      },
      expression: "name"
    }
  })], 1), _c('template', {
    slot: "bottom"
  }, [_c('Button', {
    staticClass: "my-2 my-sm-4 w-100 w-sm-auto",
    attrs: {
      "ghost": "",
      "text": _vm.$translate('cancel'),
      "disabled": _vm.saving
    },
    on: {
      "click": function click($event) {
        return _vm.hideModal();
      }
    }
  }), _c('Button', {
    staticClass: "my-2 my-sm-4 w-100 w-sm-auto ml-sm-3",
    attrs: {
      "text": _vm.$translate('create'),
      "disabled": _vm.saving || !_vm.name.trim(),
      "loading": _vm.saving
    },
    on: {
      "click": _vm.submit
    }
  })], 1)], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }